<template>
  <div id="disclaimer" class="text-500">
    <h3 class="text-sm text-primary uppercase mb-1">
      <i
        class="fa fa-asterisk"
      />
      Disclaimer
    </h3>
    <p class="my-0 text-xs font-italic">
      The information contained in this site is provided for informational purposes only, and should not be construed as engineering advice on any subject matter.
    </p>
    <p class="my-0 text-xs font-italic">
      You should not act or refrain from acting on the basis of any content included in this site without consulting a licensed engineer. The contents of this site contain general information and may not reflect current enginering specifications and/or local, state, or federal requirements.
    </p>
    <p class="my-0 text-xs font-italic">
      While Daughtridge Sales makes every effort to provide accurate information, we disclaim all liability for actions you take or fail to take based on any content on this site.
    </p>
  </div>
</template>
